import { AxiosError } from 'axios';
import { useState } from 'react';

import { ErrorHttpResponse, HttpConfig, SuccessHttpResponse } from '../../../models/https';
import useHttps from '../../useHttps';

const useDriverData = () => {
    const request = useHttps();
    // const dispatch = useAppDisPatch();
    const [loading, setLoading] = useState(false);

    const onDriverDataError = (err: AxiosError<ErrorHttpResponse>) => {
        console.error(err?.response?.data?.message ?? 'Something went wrong');
    };

    const onDriverDataSuccess = ({
        data,
        message,
    }: SuccessHttpResponse<any>) => {
        // }: SuccessHttpResponse<DriverDataInterface>) => {
        // dispatch(driverDataActions.setDriverData(data));
    };

    const driverData = async () => {
        const url: HttpConfig = {
            url: `ba/v1/company/kyc`,
            method: 'get',
        };

        return request(url, onDriverDataSuccess, setLoading, onDriverDataError);
    };

    return { driverData, loading };
};

export default useDriverData;
